(() => {

  const targetSection = document.currentScript.dataset.sectionId;
  const section = document.getElementById(targetSection)

  const countdown = section.querySelector('.countdown')

  let { endDate } = countdown.dataset;

    console.log("123")
    const timerWrapper = section.querySelector('.countdown__units');
    const timerWrapperItem = section.querySelector('span');
    timerWrapper.setAttribute(
      'style',
      `--item-width: ${timerWrapperItem.offsetWidth}px`
    );

    endDate = new Date(`${endDate}T00:00:00`).getTime();

    function updateCountdown() {
      console.log("123")
      let now = new Date().getTime();

      if (now >= endDate) {
        clearInterval(intervalID);
      }

      const timeLeft = endDate - now;

      if(timeLeft < 0) {
        return
      }

      const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      const hours =
        Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

      section.querySelector('#days').innerHTML =
        `${days}`.length === 1 ? `0${days}` : days;
      section.querySelector('#hours').innerHTML =
        `${hours}`.length === 1 ? `0${hours}` : hours;
      section.querySelector('#minutes').innerHTML =
        `${minutes}`.length == 1 ? `0${minutes}` : minutes;
      section.querySelector('#seconds').innerHTML =
        `${seconds}`.length == 1 ? `0${seconds}` : seconds;
    }

    const intervalID = setInterval(updateCountdown, 1000);

    section.querySelector('[data-close]')?.addEventListener('click', () => {
      clearInterval(intervalID);
      section.style.display = 'none';
    });
  
})();